export const COUNTDOWN_INTERVAL = 1000; // milliseconds
export const INITIAL_COUNTDOWN = 5; // seconds
